<template>
  <div>
    <div class="icon" :class="`icon-${icon}`"></div>
    <div class="image" :class="`image-${image}`" >
      <img :src="imageSrc" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    icon: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageSrc() {
      return require(`@/assets/svg/2fa/image-${this.image}.svg`);
    },
  },
};
</script>

<style lang="sass" scoped>
  .icon
    height: 250px
    width: 250px

  .icon-danger
    background: url("~@/assets/svg/2fa/icon-danger.svg") no-repeat center

  .icon-send
    background: url("~@/assets/svg/2fa/icon-send.svg") no-repeat center

  .icon-success
    background: url("~@/assets/svg/2fa/icon-success.svg") no-repeat center

  .image
    position: absolute
    right: -100px
    bottom: 0

  .image-blocked
    bottom: 62%
    left: 50%
    transform: translate(-50%, 50%)
    display: flex
    justify-content: center

  .image-error
    bottom: -50px
    right: -50px
</style>
